import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';

import type { CoachNotificationPreferencesState } from '../components/notification-preferences';

const preferencesUrl = buildUrl('/coaches/me/notification-preferences');

/** Partial merge — only the toggled keys need to be sent. */
export type CoachNotificationPreferencesUpdate = Partial<CoachNotificationPreferencesState>;

/** PATCH `/api/v1/coaches/me/notification-preferences`. Returns the full, refreshed set. */
export async function updateCoachNotificationPreferences(
  data: CoachNotificationPreferencesUpdate,
): Promise<CoachNotificationPreferencesState> {
  return await usKidsGolfService.patch<CoachNotificationPreferencesState>(preferencesUrl, data);
}

/**
 * Reads the saved preferences. The API has no GET, so this sends the partial-merge PATCH with no
 * keys: nothing changes server-side and the response echoes back all three values.
 */
export async function readCoachNotificationPreferences(): Promise<CoachNotificationPreferencesState> {
  return await updateCoachNotificationPreferences({});
}
